@use '@/styles/tokens' as *;

.card {
  overflow: hidden;
  background: $color-neutral-0;
  border: 1px solid var(--border-subtle);
  // No radius token for 20px; the app hardcodes card corner radii (see overlay/detail cards).
  border-radius: 20px;
  box-shadow: var(--shadow-surface);
}

.header {
  position: relative;
  overflow: hidden;
  padding: var(--space-6);
  background: $color-light-brown-100;
}

.pattern {
  pointer-events: none;
  user-select: none;
  position: absolute;
  inset-inline: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.9;
  z-index: 0;
}

.heading {
  position: relative;
  z-index: 1;
  margin: 0;
  font-family: $font-family-heading;
  font-size: $font-size-xl; // 20px
  font-weight: $font-weight-medium; // 500 — medium weight per Figma
  color: var(--text-primary);
}

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  margin: 0;
  padding: var(--space-6);
}

.row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-4);
}

.label {
  color: var(--text-tertiary);
}

.value {
  margin: 0;
  font-weight: $font-weight-semibold;
  color: var(--text-primary);
  text-align: end;
}

// Secondary line under a value (the Trigger's date window).
.subValue {
  display: block;
  white-space: nowrap;
}

// Info icon on the Amount/Percentage row (quantity-based only).
.infoIcon {
  margin-inline-start: var(--space-1);
  color: var(--text-disabled);
  vertical-align: middle;
}

// Quantity-Based mini tier table (Figma 4612-1078490 / 8328-1021599).
.qtySection {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin: 0;
}

.qtyHeading {
  font-weight: $font-weight-semibold;
  color: var(--text-primary);
}

.qtyBehaviour {
  margin: 0 0 var(--space-3);
  color: var(--text-tertiary);
  font-size: $font-size-sm;
}

.qtyTable {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.qtyTableHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: var(--space-2);
  border-bottom: 1px solid var(--border-subtle);
  color: var(--text-tertiary);
  font-size: $font-size-xs;
}

.qtyRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

// Green accent range chip: "1 - 5 units".
.qtyChip {
  padding: var(--space-1) var(--space-3);
  border-radius: var(--radius-pill);
  background: $color-accent2-300;
  color: var(--text-primary);
  font-size: $font-size-sm;
  font-weight: $font-weight-medium;
  white-space: nowrap;
}

.qtyUnits {
  color: var(--text-muted);
  font-weight: $font-weight-regular;
}

.qtyUnitValue {
  font-weight: $font-weight-semibold;
  color: var(--text-primary);
  white-space: nowrap;
}

.qtyPerUnit {
  color: var(--text-muted);
  font-weight: $font-weight-regular;
}

// "Above $X" centred divider between capped and exceeding tiers (allow-higher).
.qtyDivider {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  color: var(--text-muted);
  font-size: $font-size-xs;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-top: 1px solid var(--border-subtle);
  }
}
